import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from "react";
import * as PropTypes from "prop-types";
import { SearchkitManager } from "../SearchkitManager";
export var SearchkitProvider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SearchkitProvider, _React$Component);

  function SearchkitProvider() {
    _classCallCheck(this, SearchkitProvider);

    return _possibleConstructorReturn(this, _getPrototypeOf(SearchkitProvider).apply(this, arguments));
  }

  _createClass(SearchkitProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.searchkit.setupListeners();
      this.props.searchkit.completeRegistration();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var searchkit = this.props.searchkit;
      searchkit.unlistenHistory();
      searchkit.guidGenerator.reset();
    }
  }, {
    key: "getChildContext",
    value: function getChildContext() {
      return {
        searchkit: this.props.searchkit
      };
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return SearchkitProvider;
}(React.Component);
SearchkitProvider.childContextTypes = {
  searchkit: PropTypes.instanceOf(SearchkitManager)
};
SearchkitProvider.propTypes = {
  searchkit: PropTypes.instanceOf(SearchkitManager).isRequired,
  children: PropTypes.element.isRequired
};